module.exports = __webpack_public_path__ + "static/media/fruit.afe01732.png";